import { Component } from '@angular/core';
import { FeaturePreviewComponent } from '../feature-preview.component';

@Component({
  selector: 'app-feature-preview-offert',
  templateUrl: './offert.component.html',
})
export class FeaturePreviewOffert extends FeaturePreviewComponent {}
